import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BrandMarkDark } from "../components/BrandMark";

export default function ResetPassword() {
    const { token } = useParams();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [info, setInfo] = useState(null);
    const [err, setErr] = useState("");
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        api.get(`/auth/reset-password/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(formatApiError(e.response?.data?.detail) || "Odkaz je neplatný"));
    }, [token]);

    const onSubmit = async (e) => {
        e.preventDefault(); setErr("");
        if (pw.length < 10) { setErr("Heslo musí mít alespoň 10 znaků"); return; }
        if (pw !== pw2) { setErr("Hesla se neshodují"); return; }
        setLoading(true);
        try {
            const { data } = await api.post("/auth/reset-password", { token, password: pw });
            setUser?.(data);
            navigate("/");
        } catch (ex) { setErr(formatApiError(ex.response?.data?.detail) || "Nastavení hesla selhalo"); }
        finally { setLoading(false); }
    };

    const input = "w-full px-4 py-3 border border-slate-300 bg-white text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 focus:border-transparent rounded-sm";
    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <div className="w-full max-w-md bg-white border border-slate-200 sharp-shadow p-8" data-testid="reset-password-page">
                <div className="mb-8"><BrandMarkDark /></div>
                <div className="label-eyebrow mb-2">Obnova hesla</div>
                <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mb-6">Nastavte si nové heslo</h1>
                {err && !info ? (
                    <div className="space-y-4"><div className="border-l-4 border-red-600 bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="reset-invalid">{err}</div><Link to="/zapomenute-heslo" className="text-sm font-semibold text-orange-600 hover:underline">Vyžádat nový odkaz</Link></div>
                ) : !info ? <div className="text-xs uppercase tracking-widest text-slate-500">Načítání…</div> : (
                    <form onSubmit={onSubmit} className="space-y-4">
                        <div><label className="label-eyebrow block mb-2">Účet</label><input value={info.email} disabled className={input + " bg-slate-100 text-slate-500"} /></div>
                        <div><label className="label-eyebrow block mb-2">Nové heslo (min. 6 znaků)</label><input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-password" className={input} /></div>
                        <div><label className="label-eyebrow block mb-2">Nové heslo znovu</label><input type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="reset-password2" className={input} /></div>
                        {err && <div className="border-l-4 border-red-600 bg-red-50 px-4 py-2 text-sm text-red-700" data-testid="reset-error">{err}</div>}
                        <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 font-semibold uppercase tracking-wider text-sm disabled:opacity-50 rounded-sm">
                            {loading ? "Ukládám…" : "Uložit heslo a přihlásit"} <ArrowRight className="w-4 h-4" />
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
